export const pathSettled = (path, queryParams) => {
  if (/\/explorer/.test(path)) {
    const queryKeys = Object.keys(queryParams)
    return ['explorerSubScope', 'globalScope', 'globalScroll', 'globalTimeFrame'].every((key) =>
      queryKeys.includes(key)
    )
  }
  return true
}
